import { Personal, Professional, Technical } from "./sections";
import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();
export default {
    Personal,
    Professional,
    Technical,
};
